module.exports = __webpack_public_path__ + "static/media/keywordsearch.f495f129.gif";